function initHomesGrid(block) {
    if (block.dataset.p7HomesGridInit) return; // avoid double init
    block.dataset.p7HomesGridInit = '1';

    const gridContainer = block.querySelector('.p7-homes-grid');
    const loadMoreBtn = block.querySelector('.p7-load-more');
    const loadingEl = block.querySelector('.p7-loading');
    const filters = block.querySelectorAll('.p7-filter[type="radio"], .p7-filter:not([type="radio"])');
    const resetBtn = block.querySelector('.p7-reset-filters');
    const countElement = block.querySelector(".p7-home-count");

    const attributes = JSON.parse(block.dataset.attributes || '{}');
    const ajaxurl = block.dataset.ajaxurl;
    const nonce = block.dataset.nonce;

    let currentPage = 1;
    let maxPages = 1;
    let isLoading = false;
    let currentFilters = {};

    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get('custom') === '1') {
        currentFilters.home_type = 'semi-custom-homes';
    }

    if (urlParams.get('type') === 'available') {
        currentFilters.home_type = 'quick-move-in-homes';
    }

    if (currentFilters.home_type) {
        document
            .querySelector(`input[name="home_type"][value="${currentFilters.home_type}"]`)
            ?.click();
    }

    loadHomes(1, currentFilters);

    if (loadMoreBtn) loadMoreBtn.addEventListener('click', loadMoreHomes);
    filters.forEach(filter => filter.addEventListener('change', applyFilters));
    if (resetBtn) resetBtn.addEventListener('click', resetFilters);

    function loadHomes(page = 1, filters = {}) {
        if (isLoading || !ajaxurl || !nonce) return;

        isLoading = true;
        currentPage = page;

        if (loadingEl) loadingEl.style.display = 'flex';
        if (page === 1) gridContainer.innerHTML = '';

        fetch(ajaxurl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                action: 'p7_load_homes',
                nonce: nonce,
                page: page,
                attributes: JSON.stringify(attributes),
                filters: JSON.stringify(filters)
            })
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    if (page === 1) {
                        gridContainer.innerHTML = data.data.html;
                    } else {
                        gridContainer.insertAdjacentHTML('beforeend', data.data.html);
                    }

                    if (countElement && data?.data?.total_found !== undefined) {
                        countElement.textContent = `Showing ${data.data.showing} of ${data.data.total_found} results`;
                    }

                    maxPages = data.data.max_pages;
                    currentPage = data.data.current_page;
                    if (loadMoreBtn) {
                        loadMoreBtn.style.display = (currentPage < maxPages) ? 'block' : 'none';
                    }

                } else {
                    console.warn('AJAX error:', data?.data?.message || 'Unknown error');
                }
            })
            .catch(error => console.error('Fetch error:', error))
            .finally(() => {
                setTimeout(() => {
                    isLoading = false;
                    if (loadingEl) loadingEl.style.display = 'none';
                }, 500);
            });
    }

    function loadMoreHomes() {
        if (currentPage < maxPages) loadHomes(currentPage + 1, currentFilters);
    }

    function applyFilters() {
        currentFilters = {};
        filters.forEach(filter => {
            if (filter.type === 'radio') {
                if (filter.checked) {
                    const filterName = filter.name;
                    currentFilters[filterName] = filter.value;
                }
            } else if (filter.value) {
                const filterName = filter.id.replace('p7-', '').replace('-filter', '');
                currentFilters[filterName] = filter.value;
            }
        });
        loadHomes(1, currentFilters);
    }

    function resetFilters() {
        filters.forEach(filter => {
            if (filter.type === 'radio') {
                const name = filter.name;
                const defaultRadio = document.querySelector(`input[type="radio"][name="${name}"][value="all"]`);
                if (defaultRadio) defaultRadio.checked = true;
            } else {
                filter.value = '';
            }
        });

        currentFilters = {};
        loadHomes(1);
    }
}

// Observe DOM for dynamically inserted blocks (covers editor dynamic loading)
const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
        mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) {
                if (node.classList.contains('p7-homes-grid-block')) {
                    initHomesGrid(node);
                }
                node.querySelectorAll?.('.p7-homes-grid-block').forEach(initHomesGrid);
            }
        });
    }
});

if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
}


// Also init any blocks present on initial DOM ready
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.p7-homes-grid-block').forEach(initHomesGrid);
});


